/* eslint-disable ember/no-computed-properties-in-native-classes */
import { reads } from '@ember/object/computed';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type AbilitiesService from 'ember-can/services/abilities';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type FlowService from 'garaje/services/flow';
import type IntegrationTelemetryConfigService from 'garaje/services/integration-telemetry-config';
import type StateService from 'garaje/services/state';

export default class IntegrationsMenuComponent extends Component {
  @service declare abilities: AbilitiesService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare state: StateService;
  @service declare integrationTelemetryConfig: IntegrationTelemetryConfigService;
  @service('flow') declare employeeScreeningFlow: FlowService;

  @reads('employeeScreeningFlow.activeEmployeeScreeningFlow')
  activeEmployeeScreeningFlow!: FlowService['activeEmployeeScreeningFlow'];
  @reads('state.currentLocation') currentLocation!: StateService['currentLocation'];

  get showHealthDashboard(): boolean {
    const locationId = this.state.currentLocation?.id;
    if (locationId) {
      this.integrationTelemetryConfig.ensureLoadedForLocation(String(locationId));
    }
    return (
      this.featureFlags.isEnabled('integration-health-dashboard') && this.integrationTelemetryConfig.hasDataForLocation
    );
  }

  get showAppsSettings(): boolean {
    return (
      this.featureFlags.isEnabled('show-acs-failure-alert-toggle') ||
      this.featureFlags.isEnabled('show-data-missing-alert-toggle') ||
      this.featureFlags.isEnabled('show-binary-download-modal') ||
      this.featureFlags.isEnabled('show-diplomat-client-config-modal')
    );
  }
}
